import { useEffect, useRef, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ShieldX } from "lucide-react";
import api from "@/lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const [denied, setDenied] = useState(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const params = new URLSearchParams(hash.substring(1));
    const sessionId = params.get("session_id");

    if (sessionId) {
      api.post("/auth/session", { session_id: sessionId })
        .then((res) => {
          window.history.replaceState(null, "", window.location.pathname);
          navigate("/admin", { state: { user: res.data } });
        })
        .catch((err) => {
          window.history.replaceState(null, "", window.location.pathname);
          if (err.response?.status === 403) {
            setDenied(true);
          } else {
            navigate("/");
          }
        });
    } else {
      navigate("/");
    }
  }, [navigate]);

  if (denied) {
    return (
      <div className="min-h-screen bg-bone flex items-center justify-center px-6" data-testid="access-denied-page">
        <div className="max-w-md text-center">
          <div className="w-16 h-16 rounded-full bg-red-50 flex items-center justify-center mx-auto mb-6">
            <ShieldX className="w-8 h-8 text-red-500" />
          </div>
          <h1 className="font-cormorant text-3xl font-light text-midnight mb-3">Access Denied</h1>
          <p className="font-manrope text-sm text-midnight/50 mb-6">
            This email is not authorized for admin access. Only approved administrators can log in to the dashboard.
          </p>
          <p className="font-manrope text-xs text-midnight/30 mb-8">
            If you believe this is an error, contact the site administrator.
          </p>
          <Link to="/" data-testid="denied-home-btn">
            <Button className="rounded-full bg-sandy text-midnight hover:bg-sandy/90 font-manrope text-sm px-8">
              Return to Homepage
            </Button>
          </Link>
        </div>
      </div>
    );
  }

  return null;
}
